var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "progress_activity"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "progress_activity_2",
    d: "M30.0927 54.9971C26.676 54.9971 23.4469 54.3408 20.4052 53.0283C17.3635 51.7158 14.7073 49.9242 12.4364 47.6533C10.1656 45.3825 8.37394 42.7263 7.06144 39.6846C5.74894 36.6429 5.09269 33.4138 5.09269 29.9971C5.09269 26.5388 5.74894 23.2992 7.06144 20.2783C8.37394 17.2575 10.1656 14.6117 12.4364 12.3409C14.7073 10.07 17.3635 8.27835 20.4052 6.96585C23.4469 5.65335 26.676 4.9971 30.0927 4.9971C30.801 4.9971 31.3948 5.23669 31.8739 5.71585C32.3531 6.19502 32.5927 6.78877 32.5927 7.4971C32.5927 8.20544 32.3531 8.79919 31.8739 9.27835C31.3948 9.75752 30.801 9.9971 30.0927 9.9971C24.551 9.9971 19.8323 11.945 15.9364 15.8408C12.0406 19.7367 10.0927 24.4554 10.0927 29.9971C10.0927 35.5388 12.0406 40.2575 15.9364 44.1533C19.8323 48.0492 24.551 49.9971 30.0927 49.9971C35.6343 49.9971 40.3531 48.0492 44.2489 44.1533C48.1448 40.2575 50.0927 35.5388 50.0927 29.9971C50.0927 29.2888 50.3323 28.695 50.8114 28.2158C51.2906 27.7367 51.8843 27.4971 52.5927 27.4971C53.301 27.4971 53.8948 27.7367 54.3739 28.2158C54.8531 28.695 55.0927 29.2888 55.0927 29.9971C55.0927 33.4138 54.4364 36.6429 53.1239 39.6846C51.8114 42.7263 50.0198 45.3825 47.7489 47.6533C45.4781 49.9242 42.8323 51.7158 39.8114 53.0283C36.7906 54.3408 33.551 54.9971 30.0927 54.9971Z",
    fill: "#185DD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressActivity);
export default __webpack_public_path__ + "static/media/progress-activity.26ac2aa5c8bc68134e2f4d5003a90969.svg";
export { ForwardRef as ReactComponent };